import { createSlice } from '@reduxjs/toolkit';

const LOCATION_STORAGE_KEY = 'bookizap_user_location';
const RECENT_LOCATIONS_KEY = 'bookizap_recent_locations';

// Load initial state from localStorage
const loadLocationFromStorage = () => {
  try {
    const saved = localStorage.getItem(LOCATION_STORAGE_KEY);
    return saved ? JSON.parse(saved) : null;
  } catch (error) {
    
    return null;
  }
};

const loadRecentLocationsFromStorage = () => {
  try {
    const saved = localStorage.getItem(RECENT_LOCATIONS_KEY);
    return saved ? JSON.parse(saved) : [];
  } catch (error) {
    
    return [];
  }
};

const initialState = {
  currentLocation: loadLocationFromStorage(),
  recentLocations: loadRecentLocationsFromStorage(),
  isDetecting: false,
  error: null,
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setLocation: (state, action) => {
      state.currentLocation = action.payload;
      state.error = null;

      // Save to localStorage
      try {
        localStorage.setItem(LOCATION_STORAGE_KEY, JSON.stringify(action.payload));
      } catch (error) {
        
      }
    },

    addRecentLocation: (state, action) => {
      const newLocation = action.payload;

      // Remove duplicate if exists (based on coordinates)
      state.recentLocations = state.recentLocations.filter(
        loc =>
          loc.coordinates.latitude !== newLocation.coordinates.latitude ||
          loc.coordinates.longitude !== newLocation.coordinates.longitude
      );

      // Add to beginning
      state.recentLocations.unshift(newLocation);

      // Keep only last 5 locations
      state.recentLocations = state.recentLocations.slice(0, 5);

      // Save to localStorage
      try {
        localStorage.setItem(RECENT_LOCATIONS_KEY, JSON.stringify(state.recentLocations));
      } catch (error) {
        
      }
    },

    setDetecting: (state, action) => {
      state.isDetecting = action.payload;
    },

    setLocationError: (state, action) => {
      state.error = action.payload;
      state.isDetecting = false;
    },

    clearLocation: (state) => {
      state.currentLocation = null;
      state.error = null;

      // Clear from localStorage
      try {
        localStorage.removeItem(LOCATION_STORAGE_KEY);
      } catch (error) {
        
      }
    },

    clearRecentLocations: (state) => {
      state.recentLocations = [];

      // Clear from localStorage
      try {
        localStorage.removeItem(RECENT_LOCATIONS_KEY);
      } catch (error) {
        
      }
    },
  },
});

export const {
  setLocation,
  addRecentLocation,
  setDetecting,
  setLocationError,
  clearLocation,
  clearRecentLocations,
} = locationSlice.actions;

// Selectors
export const selectCurrentLocation = (state) => state.location.currentLocation;
export const selectRecentLocations = (state) => state.location.recentLocations;
export const selectIsDetecting = (state) => state.location.isDetecting;
export const selectLocationError = (state) => state.location.error;

export default locationSlice.reducer;
